import { Menu as AntdMenu } from "antd";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { getRoutes } from "../../../../routes/Routes";

const Menu = ({ onMenuClick }) => {
    const location = useLocation();

    const { user } = useSelector((state) => state.authSlice);

    const menuItems = Object.entries(getRoutes())
        ?.filter(
            ([, route]) => route?.icon && (!route.allowedRoles || route.allowedRoles.includes(user?.role))
        )
        ?.sort(([, a], [, b]) => (a.menuOrder ?? 0) - (b.menuOrder ?? 0))
        ?.map(([key, route]) => ({
            key: route.path,
            icon: route.icon,
            label: <Link onClick={onMenuClick} to={route.path}>{route.name}</Link>,
        }));

    const activePage = '/' + (location?.pathname?.split('/')[1] || '');

    return (
        <AntdMenu
            mode="inline"
            selectedKeys={[activePage]}
            theme="light"
            style={{ height: '100%', borderRight: 'none' }}
            items={menuItems}
        />
    )
}

export default Menu